const base_url = 'https://apiv1.kaduidui.com/'

export default base_url